<script context="module">
  import { clientIsBot, initDatadogLogs } from "$lib/utilities/datadog/browser-logs";
  import isPreviewBuild from "$lib/utilities/isPreviewBuild";
</script>

<script>
  import "../app.css";

  import { onMount, setContext } from "svelte";

  import GTM from "$lib/components/GTM.svelte";
  import Header from "$lib/components/Header.svelte";
  import Footer from "$lib/components/Footer.svelte";
  import { Button, DynamicHeadingContext } from "@ObamaFoundation/of-design-system";
  import FundraiseUpRedirects from "$lib/components/FundraiseUpRedirects.svelte";
  import VWO from "$lib/components/VWO.svelte";
  import WithBanner from "$lib/components/WithBanner.svelte";
  import OneTrust from "$lib/components/OneTrust.svelte";
  import { initializeContentfulPreview } from "$lib/utilities/live-Preview.js";

  export let data;

  const isPreview = isPreviewBuild();

  let fundraiseUpScript;
  let viewportHeight;
  let topBannerHeight = 0;

  onMount(async () => {
    // Until we fix hydration, there's no reason to check for this.  It must run when the page is loaded.
    //if (import.meta.env.MODE !== 'production') {
    //}

    if (!clientIsBot(navigator.userAgent) && !window.DD_RUM?.getInternalContext()) {
      //TODO: Uncomment this when we turn it on.
      //initDatadogMonitoring();

      initDatadogLogs();
    }

    //Set mode to correct live mode before adding script to the page.
    window.fundraiseup_livemode = import.meta.env.VITE_FUNDRAISE_UP_LIVE_MODE === "true"; // if true, FundraiseUp is live
    fundraiseUpScript = "https://cdn.fundraiseup.com/widget/AHNVSXNQ";

    // Initialize Contentful Preview
    await initializeContentfulPreview(isPreview);
  });

  // add feature flags to context
  setContext("featureFlags", data.featureFlags);
</script>

<svelte:window bind:innerHeight={viewportHeight} />

<svelte:head>
  {#if fundraiseUpScript}
    <script async src={fundraiseUpScript}></script>
  {/if}
</svelte:head>

<VWO />

<FundraiseUpRedirects redirects={data.fruRedirects} />

<DynamicHeadingContext>
  <div data-headings-start>
    <Button
      id="skip-to-content"
      url="#main"
      theme="white"
      label="Skip to content"
      variant="filled"
      buttonClass="!absolute !z-[--stack-level-layer-top] !left-4 !top-[-100px] focus-visible:!top-4 hover:bg-white"
    />

    {#if data.featureFlags?.useOneTrust && !isPreview}
      <OneTrust />
    {/if}

    <GTM cookieBanner={data.featureFlags?.useOneTrust ? undefined : data.cookieBanner} />

    <WithBanner data={data.alertBanner} bind:topBannerHeight>
      <Header data={data.header} activePrimaryUrl={data.activePrimaryUrl} {topBannerHeight} />
    </WithBanner>

    <main
      id="main"
      tabindex="-1"
      class="flex-1 relative focus:outline-none min-h-screen"
      data-headings-increment=""
    >
      <slot />
    </main>

    <Footer data={data.footer} />
  </div>
</DynamicHeadingContext>
